import { render, staticRenderFns } from "./ConvertPayloads.vue?vue&type=template&id=af841660&scoped=true&"
import script from "./ConvertPayloads.vue?vue&type=script&lang=ts&"
export * from "./ConvertPayloads.vue?vue&type=script&lang=ts&"
import style0 from "./ConvertPayloads.vue?vue&type=style&index=0&id=af841660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af841660",
  null
  
)

export default component.exports